export default __webpack_public_path__ + "static/media/coloredLogo.1e3d15c2.svg";